/* ------------------------------ */
/* Kill Click Function */
/* ------------------------------ */

window.killclick = function killclick(e) {
    'use strict';
    if (e.preventDefault) {
        e.preventDefault();
    } else {
        e.returnValue = false;
    }
}